/* bristm-work-hero — collage motion (loaded only where the section renders)
 *  - Pauses the CSS float while the hero is off screen (.is-visible)
 *  - Scroll parallax: each [data-b-work-drift="factor"] layer moves by
 *    scroll distance × factor (transform only, rAF, passive listener,
 *    active only while the hero is visible). Honours reduced motion.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(hero) {
    if (hero.dataset.bWorkBound) return;
    hero.dataset.bWorkBound = '1';

    var layers = Array.prototype.slice.call(hero.querySelectorAll('[data-b-work-drift]')).map(function (el) {
      return { el: el, f: parseFloat(el.getAttribute('data-b-work-drift')) || 0 };
    });
    var visible = false;
    var frame = 0;

    function update() {
      frame = 0;
      if (!visible || reduce.matches) return;
      var top = hero.getBoundingClientRect().top; // read
      var dist = Math.min(Math.max(-top, -400), 1200);
      layers.forEach(function (l) {
        l.el.style.transform = 'translate3d(0,' + (dist * l.f).toFixed(1) + 'px,0)'; // write
      });
    }

    function onScroll() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          hero.classList.toggle('is-visible', visible);
          if (visible) onScroll();
        },
        { threshold: 0 }
      ).observe(hero);
    } else {
      visible = true;
      hero.classList.add('is-visible');
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    reduce.addEventListener &&
      reduce.addEventListener('change', function () {
        if (reduce.matches) {
          layers.forEach(function (l) {
            l.el.style.transform = '';
          });
        } else {
          onScroll();
        }
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-work-hero]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
